import React from 'react';
import { Button } from 'flowbite-react';
import { FiTrash2 } from 'react-icons/fi';

interface ClearLocalCacheButtonProps {
  workspaceId?: string;
  className?: string;
}

const ClearLocalCacheButton: React.FC<ClearLocalCacheButtonProps> = ({ workspaceId, className }) => {
  const clearLocalCache = () => {
    if (!workspaceId) return;

    // TODO move this delete-indexeddb operation down to Rust / WASM for consistency.
    const request = indexedDB.open("chronomap");

    request.onsuccess = () => {
      const db = request.result;
      const transaction = db.transaction(["data"], "readwrite");
      const objectStore = transaction.objectStore("data");

      // Delete the record with the key matching workspaceId
      const deleteRequest = objectStore.delete(workspaceId);

      deleteRequest.onsuccess = () => {
        console.log(`Successfully cleared local cache for workspace: ${workspaceId}`);
        // Reload the page to reflect changes
        window.location.reload();
      };

      deleteRequest.onerror = () => {
        console.error(`Error clearing local cache for workspace: ${workspaceId}`);
      };

      transaction.oncomplete = () => {
        db.close();
      };
    };

    request.onerror = () => {
      console.error("Error opening database");
    };
  };

  return (
    <Button
      onClick={clearLocalCache}
      color="blue"
      className={className}
      disabled={!workspaceId}
      title={!workspaceId ? "No workspace selected" : "Clear local cache for this workspace"}
    >
      <FiTrash2 className="mr-2" />
      Clear Local Cache
    </Button>
  );
};

export default ClearLocalCacheButton;
